export default __webpack_public_path__ + "static/media/K.b2415f28.png";